import React, { useState, useEffect, useRef } from "react";
import { newFetch, POST, GET } from "../../../helpers/fetch";
import { withRouter } from "react-router-dom";
import { config } from "../../../config";
//import UploadArt from '../../Input/UploadART'
import moment from "moment";
import imageCompression from "browser-image-compression";
import SignaturePad from "react-signature-canvas";
import queryString from "query-string";
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";
import styles from "./styles.css";

const { SERVER_URL } = config;

const CollectForm = ({
  history,
  match: {
    params: { id },
  },
}) => {
  const [mobile, setMobile] = useState();
  const [test_result, setTestResult] = useState(0);
  const [shift, setShift] = useState();
  const [location, setLocation] = useState();
  const [hasError, setHasError] = useState(false);
  const [files, setFiles] = useState([]);
  const [submitLabel, setSubmitLabel] = useState("Sign");
  const [assignedList, setAssignedList] = useState("");
  const [formState, setFormState] = useState({
    remarks: "",
    isSigned: false,
  });
  const fetchAssignedDeliveryOrder = async () => {
    let api_path = `/delivery-order/${id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setAssignedList(response.data);
    } else {
      ToastUtil.error(response.message);
      setHasError(true);
    }
  };

  const fetchSignaturesByDeliveryOrder = async () => {
    let api_path = `/delivery-order/${id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setAssignedList(response.data);
    }
  };

  useEffect(() => {
    fetchAssignedDeliveryOrder();
  }, []);

  const handleValidation = () => {
    if (!test_result) {
      ToastUtil.error("Please select Test Result!");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (hasError) {
      ToastUtil.error("Unable to submit this form.");
      return;
    }

    // Confirmation dialog
    const confirmAction = await AlertService.confirm(
      "",
      "Are you sure you want to complete signing?"
    );
    if (!confirmAction) return;

    try {
      setSubmitLabel("Signing...");

      // Validate signature pad
      if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
        ToastUtil.error("Please provide a signature before submitting.");
        setSubmitLabel("Sign");
        return;
      }

      // Initialize FormData
      let formData = new FormData();
      formData.append("do_id", id);
      formData.append("remarks", formState.remarks);
      // Convert data URL to Blob
      const dataURL = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      const blob = await (await fetch(dataURL)).blob();
      formData.append("image", blob, "signature.png");

      // API Call
      const apiPath = `/delivery-order/signature`;
      const response = await newFetch(POST, apiPath, formData, "multi");

      // Handle API response
      if (response.success) {
        ToastUtil.success("Signing completed successfully.");
        window.location.reload(false); // Consider using state for better UX
      } else {
        ToastUtil.error(response.message);
        setSubmitLabel("Sign");
      }
    } catch (error) {
      console.error("Error during submission:", error);
      ToastUtil.error("An error occurred. Please try again.");
      setSubmitLabel("Sign");
    }
  };

  const [trimmedDataURL, setTrimmedDataURL] = useState(null); // State for trimmed signature
  const sigPadRef = useRef(null); // Reference for SignaturePad instance

  // Clear the signature pad
  const clear = () => {
    if (sigPadRef.current) {
      sigPadRef.current.clear();
      setFormState((prev) => ({ ...prev, isSigned: false })); // Reset isSigned when cleared
    }
  };

  // Trim the signature and save the image data URL
  const trim = (e) => {
    e.preventDefault();
    if (sigPadRef.current) {
      const trimmedData = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setTrimmedDataURL(trimmedData);
    }
  };

  const handleSignature = () => {
    setFormState((prev) => ({
      ...prev,
      isSigned: !sigPadRef.current.isEmpty(),
    }));
  };

  const handleDownloadClick = async (signed_id, image, name) => {
    let api_path = `/delivery-order/view-preview/${id}`;
    let response = await newFetch(POST, api_path, {
      site: assignedList.site?.name,
      name,
      image,
      signed_id: signed_id,
      catalogues: assignedList.catalogues,
    });

    if (response.success) {
      response.result && openInNewTab(`${SERVER_URL}/${response.result}`);
    }
  };

  const openInNewTab = (url) => {
    let win = window.open(url, "_blank");
    win.focus();
  };

  return (
    <form className="form" onSubmit={(e) => handleSubmit(e)}>
      <div className="d-flex flex-column">
        <div
          style={{
            fontSize: "15px",
            fontWeight: "600",
            lineHeight: "20px",
            textAlign: "left",
            color: "#495057",
          }}
          className="pt-4 pb-1"
        >
          {assignedList.site?.name}
        </div>
        <div
          style={{
            fontSize: "10px",
            fontWeight: "500",
            lineHeight: "13px",
            textAlign: "left",
            color: "#b7b3b3",
          }}
          className="pb-3"
        >
          {moment(assignedList.createdAt).format("dddd, DD MMM YYYY")}
        </div>
        <div className="form-group pt-3">
          <label
            htmlFor="userName"
            className="text-bold"
            style={{ color: "#4c9597" }}
          >
            DO No. {assignedList.id}
          </label>

          {assignedList.catalogues &&
            assignedList.catalogues.map((item, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #cdcdcd",
                  padding: "10px 21px",
                  backgroundColor: "#F6F6F5",
                  borderRadius: "9px!important",
                  fontSize: "14px",
                  lineheight: "18px",
                  color: "#454343e0",
                }}
                className="rounded mb-2"
              >
                <div>Name: {item.catalogue_details.name}</div>
                <div>Expected quantity: {item.expected_quantity}</div>
              </div>
            ))}
        </div>

        <div className="form-group pt-2">
          <label
            className="text-bold"
            style={{
              fontSize: "15px",
              fontWeight: "600",
              lineHeight: "20px",
              textAlign: "left",
              color: "#495057",
            }}
          >
            Remarks
          </label>

          <div
            className="mb-5"
            // style={{
            //   height: "102px",
            //   border: "1px solid #cdcdcd",
            //   borderRadius: "10px",
            // }}
          >
            <textarea
              rows="5"
              className="form-control mt-1"
              style={{
                resize: "none",
                fontSize: "14px",
                lineHeight: "18px", // Fixed property name (lineHeight, not lineheight)
                backgroundColor: "#fff",
              }}
              value={formState.remarks}
              onChange={(e) =>
                setFormState((prev) => ({
                  ...prev,
                  remarks: e.target.value, // Update the remarks property
                }))
              }
            />
          </div>

          <small
            style={{
              fontSize: "12px",
              fontWeight: "600",
              textAlign: "left",
              color: "#707983f7",
            }}
          >
            Notes:
          </small>
          <br />
          <div
            className="pb-2"
            style={{
              fontSize: "12px",
              lineHeight: "19px",
              color: "#707983f7",
            }}
          >
            Lorem ipsum dolor sit amet. Qui placeat quidem quo perferendis quam
            ea quia cumque et architecto maiores.
          </div>

          <div className={styles.container}>
            <div
              style={{
                border: "1px solid #cdcdcd",
                borderRadius: "10px",
              }}
            >
              <SignaturePad
                canvasProps={{ className: "sigPad" }}
                ref={sigPadRef} // Attach the ref to the SignaturePad
                onEnd={handleSignature}
              />
            </div>
            <div style={{ textAlign: "right" }}>
              <button type="button" className="btn-clear" onClick={clear}>
                Clear
              </button>

              {/* <button className={styles.buttons} onClick={(e) => trim(e)}>
                Trim
              </button> */}
            </div>
            {/* {trimmedDataURL && (
              <img
                className={styles.sigImage}
                src={trimmedDataURL}
                alt="Trimmed Signature"
              />
            )} */}
          </div>
        </div>
        <button
          className="btn btn-brand btn-block mt-2"
          disabled={!(formState.isSigned)}
        >
          {submitLabel}
        </button>

        <div className="d-flex flex-column my-5">
          <h5
            className="text-brand text-underline mb-3"
            style={{
              fontSize: "15px",
              fontWeight: "600",
              lineHeight: "20px",
              textAlign: "left",
              color: "rgb(73, 80, 87)",
            }}
          >
            Recent Signs:
          </h5>
          <div
            className="card"
            style={{ backgroundColor: "#f4f8ff", border: "none" }}
          >
            {assignedList.signed &&
            assignedList.signed.map((item, index) => (
            <div
              className="row align-items-center"
              style={{ margin: "11px 7px" }}
              key={index}
            >
              <div className="col-8 menu text-left" style={{ fontSize: "13px" }}>
              {item.created_date} &nbsp;&nbsp;-&nbsp;&nbsp;{" "}
                <strong style={{ fontSize: "14px", fontWeight: "600" }}>
                  Signed by {item.assoc.first_name} {item.assoc.last_name}
                </strong>
              </div>
              {/* <div className="col-4 menu text-center text-success mt-2 mb-2">
                <span className="item" onClick={handleDownloadClick}>
                  Download
                </span>
                 <a
                  href="https://associate-jllptrack.manpower.com.sg/assets/signed_do/signed_do-1732176882-1.pdf"
                  target="_blank"
                  style={{
                    letterSpacing: "0.05em",
                    textDecorationLine: "underline",
                    color: "#466EA5",
                  }}
                >
                  <span className="item">Download</span>
                </a> *
              </div> */}
                  <div className="col-4 menu text-center text-success mt-2 mb-2">
                    <span
                      className="item link-button"
                      // onClick={handleDownloadClick}
                      onClick={() =>
                        handleDownloadClick(
                          item.id,
                          item.signed_filename,
                          `${item.assoc.first_name} ${item.assoc.last_name}`
                        )
                      }
                      role="button"
                      tabIndex="0"
                      style={{
                        color: "#466EA5",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Download
                    </span>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </form>
  );
};

export default withRouter(CollectForm);
